<div id="water-system-iwmz">
  <div class="pt-3">
    <app-potential-contaminants [well]="well"></app-potential-contaminants>
    <app-measures [well]="well"></app-measures>
  </div>
</div>
